import React, { Component } from 'react';
import FooterData from '../../data/footerdata'; 

class Footer extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return <footer id="footer-section" className="pt50 pb50 bg-black">
        <div className="container">
            <div className="row text-center">
                <div className="col social-icons">
                    {/* <ul>
                        {
                           FooterData.socialicon.map( function( data, i ) {
                               return(
                                <li key={i} className={data.class+` wow zoomIn`} data-wow-duration="1s"><a href={data.url}><i className={data.icon}></i></a>
                                </li>
                               )
                           } )
                        }
                    </ul> */}
                </div>


<div className="container-fluid" style={{ backgroundColor: "#1f1f22" }}>
  <div className="container text-white py-5" >

    {/* Ownership line */}
    <div className="row mb-4">
      <div className="col-12 text-center">
        {/* <p className="mb-0" style={{ fontWeight: 600 }}>
          Finneto is a brand owned by Finixo IL Ltd. (Israel)
        </p> */}
      </div>
    </div>

    {/* Two columns */}
    <div className="row justify-content-center">

      {/* U.S. Operations */}
      <div className="col-md-5 d-flex flex-column">

         <h6 className="mb-3" style={{ fontWeight: 600, textAlign: "start", color: "white" }}>
          U.S. Operations &amp; Billing
        </h6>

        <div className="d-flex align-items-start mb-1">
          <i
            className="pe-7s-home"
            style={{ fontSize: 20, lineHeight: 1, minWidth: 22, marginRight: 8, marginTop: 2 }}
          ></i>
          <div>
            <strong>Lorlir LLC - Registered in Wyoming, United States</strong>
          </div>
        </div>

        <div className="d-flex align-items-center mb-1">
          <i
            className="pe-7s-phone"
            style={{ fontSize: 20, lineHeight: 1, minWidth: 22, marginRight: 8 }}
          ></i>
           <a href="tel:+1(307)5333685" className="text-white text-decoration-none">
          <div>+1 (307) 533 3685</div>
          </a>
        </div>

        <div className="d-flex align-items-center">
          <i
            className="pe-7s-mail"
            style={{ fontSize: 20, lineHeight: 1, minWidth: 22, marginRight: 8 }}
          ></i>
           <a href="mailto:info@lorlir.com" className="text-white text-decoration-none">
          <div>info@lorlir.com</div>
          </a>
        </div>
      </div>

      {/* Non-U.S. Operations */}
      <div className="col-md-5 d-flex flex-column mt-4 mt-md-0">

        <h6 className="mb-3" style={{ fontWeight: 600, textAlign: "start", color: "white" }}>
          Non-U.S. Operations
        </h6>

        <div className="d-flex align-items-start mb-1">
          <i
            className="pe-7s-home"
            style={{ fontSize: 20, lineHeight: 1, minWidth: 22, marginRight: 8, marginTop: 2 }}
          ></i>
          <div>
            <strong>Finixo IL Ltd - Registered in Israel</strong>
            
          </div>
        </div>

        <div className="d-flex align-items-center mb-1">
          <i
            className="pe-7s-phone"
            style={{ fontSize: 20, lineHeight: 1, minWidth: 22, marginRight: 8 }}
          ></i>
            <a href="tel:+972772200234" className="text-white text-decoration-none">
          <div>+972 77 220 0234</div></a>
        </div>

        <div className="d-flex align-items-center">
          <i
            className="pe-7s-mail"
            style={{ fontSize: 20, lineHeight: 1, minWidth: 22, marginRight: 8 }}
          ></i>
          <a href="mailto:info@finixo.co.il" className="text-white text-decoration-none">
          <div>info@finixo.co.il</div>
          </a>
        </div>
      </div>
    </div>

    {/* Legal Links */}
    <div className="row" style={{ marginTop: '40px' }}>
      <div className="col-12 text-center">
        <div style={{ color: "rgba(255,255,255,0.8)", fontSize: 16, marginBottom: 30 }}>
          <a href="/#/privacy" className="text-white text-decoration-none" style={{ opacity: 0.8, marginRight: '30px' }}>
            Privacy Policy
          </a>
          <span style={{ color: "rgba(255,255,255,0.4)", margin: '0 15px' }}>|</span>
          <a href="/#/terms" className="text-white text-decoration-none" style={{ opacity: 0.8, marginLeft: '30px' }}>
            Terms & Conditions
          </a>
        </div>
      </div>
    </div>

    {/* Copyright */}
    <div className="row">
      <div className="col-12 text-center" style={{ color: "rgba(255,255,255,0.6)", fontSize: 12 }}>
        © 2025 Finneto. All rights reserved.
      </div>
    </div>

  </div>
</div>



            </div>
        </div>
    </footer>
    }
}



export default Footer
